import React from "react";
import { useNavigate, Link } from 'react-router-dom';
import '../../src/layouts/styles//footer.css';
const Footer = () => {
    const navigate = useNavigate();
    return (

        <footer className="site-footer">

            {/* ── Main content ── */}
            <div className="sf-main">
                <div className="sf-container">
                    <div className="sf-grid">

                        {/* Col 1 — Brand */}
                        <div className="sf-col sf-col-brand">
                            <div className="sf-logo">
                                <img
                                    src={require('../assets/img/logo/artecraftindia.jpg')}
                                    alt="Arte Craft India"
                                    className="sf-logo-img"
                                />
                                <div className="sf-logo-text">
                                    <span className="sf-logo-brand">Arte Craft</span>
                                    <span className="sf-logo-country">India</span>
                                </div>
                            </div>
                            <p className="sf-about">
                                Established in 2017, Arte Craft India is a trusted manufacturer
                                of Pom Poms, Designer Tassels, Fringes and Beaded Patches —
                                delivering quality craft products across India.
                            </p>

                            {/* Trust badges */}
                            <div className="sf-trust">
                                <div className="sf-trust-badge">
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                                         stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                                    </svg>
                                    Quality Assured
                                </div>
                                <div className="sf-trust-badge">
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                                         stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <circle cx="12" cy="12" r="10"/>
                                        <polyline points="12 6 12 12 16 14"/>
                                    </svg>
                                    Est. 2017
                                </div>
                            </div>

                            {/* Social */}
                            <div className="sf-social">
                                <a href="https://facebook.com" target="_blank" rel="noreferrer" aria-label="Facebook" className="sf-social-link">
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                                        <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
                                    </svg>
                                </a>
                                <a href="https://instagram.com" target="_blank" rel="noreferrer" aria-label="Instagram" className="sf-social-link">
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                                         stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
                                        <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/>
                                        <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/>
                                    </svg>
                                </a>
                                <a href="https://twitter.com" target="_blank" rel="noreferrer" aria-label="Twitter / X" className="sf-social-link">
                                    <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
                                        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                                    </svg>
                                </a>
                                <a href="https://youtube.com" target="_blank" rel="noreferrer" aria-label="YouTube" className="sf-social-link">
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                                        <path d="M22.54 6.42a2.78 2.78 0 0 0-1.95-1.97C18.88 4 12 4 12 4s-6.88 0-8.59.45A2.78 2.78 0 0 0 1.46 6.42 29 29 0 0 0 1 12a29 29 0 0 0 .46 5.58A2.78 2.78 0 0 0 3.41 19.6C5.12 20 12 20 12 20s6.88 0 8.59-.4a2.78 2.78 0 0 0 1.95-1.97A29 29 0 0 0 23 12a29 29 0 0 0-.46-5.58z"/>
                                        <polygon fill="#fff" points="9.75 15.02 15.5 12 9.75 8.98 9.75 15.02"/>
                                    </svg>
                                </a>
                                <a href="https://wa.me/919818548369" target="_blank" rel="noreferrer" aria-label="WhatsApp" className="sf-social-link sf-social-wa">
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                                        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51a12.8 12.8 0 0 0-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
                                        <path d="M11.999 2C6.477 2 2 6.477 2 12c0 1.89.525 3.66 1.438 5.168L2 22l4.948-1.42A9.955 9.955 0 0 0 12 22c5.523 0 10-4.477 10-10S17.523 2 12 2z" fillRule="evenodd" clipRule="evenodd"/>
                                    </svg>
                                </a>
                            </div>
                        </div>

                        {/* Col 2 — Quick Links */}
                        <div className="sf-col">
                            <h4 className="sf-heading">Quick Links</h4>
                            <ul className="sf-links">
                                <li>
                                    <button onClick={() => navigate('/')}>
                                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><path d="M5 12h14"/></svg>
                                        Home
                                    </button>
                                </li>
                                <li>
                                    <button onClick={() => navigate('/request-a-quote')}>
                                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><path d="M5 12h14"/></svg>
                                        Request a Quote
                                    </button>
                                </li>
                                <li>
                                    <button onClick={() => navigate('/cart')}>
                                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><path d="M5 12h14"/></svg>
                                        Shopping Cart
                                    </button>
                                </li>
                                <li>
                                    <button onClick={() => navigate('/login')}>
                                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><path d="M5 12h14"/></svg>
                                        Sign In
                                    </button>
                                </li>
                                <li>
                                    <button onClick={() => navigate('/register')}>
                                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><path d="M5 12h14"/></svg>
                                        Register
                                    </button>
                                </li>
                                <li>
                                    <button onClick={() => navigate('/seller/register')}>
                                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><path d="M5 12h14"/></svg>
                                        Sell on Arte Craft
                                    </button>
                                </li>
                            </ul>
                        </div>

                        {/* Col 3 — Categories */}
                        <div className="sf-col">
                            <h4 className="sf-heading">Our Products</h4>
                            <ul className="sf-links">
                                <li>
                                    <button onClick={() => navigate('/products/pom-poms')}>
                                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><path d="M5 12h14"/></svg>
                                        Pom Poms
                                    </button>
                                </li>
                                <li>
                                    <button onClick={() => navigate('/faux-fur-pom-poms')}>
                                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><path d="M5 12h14"/></svg>
                                        Faux Fur Pom Poms
                                    </button>
                                </li>
                                <li>
                                    <button onClick={() => navigate('/products/tassels')}>
                                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><path d="M5 12h14"/></svg>
                                        Tassels
                                    </button>
                                </li>
                                <li>
                                    <button onClick={() => navigate('/products/fringes')}>
                                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><path d="M5 12h14"/></svg>
                                        Fringes
                                    </button>
                                </li>
                                <li>
                                    <button onClick={() => navigate('/products/beaded-patches')}>
                                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><path d="M5 12h14"/></svg>
                                        Beaded Patches
                                    </button>
                                </li>
                            </ul>
                        </div>

                        {/* Col 4 — Contact */}
                        <div className="sf-col">
                            <h4 className="sf-heading">Contact Us</h4>
                            <ul className="sf-contact">
                                <li>
                                    <span className="sf-contact-icon">
                                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none"
                                             stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
                                            <circle cx="12" cy="10" r="3"/>
                                        </svg>
                                    </span>
                                    <span>280/13 Gali No. 29, Molarband Extn,<br />Badarpur, New Delhi – 110044</span>
                                </li>
                                <li>
                                    <span className="sf-contact-icon">
                                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none"
                                             stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.07 12 19.79 19.79 0 0 1 1 3.18 2 2 0 0 1 2.96 1h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.09 8.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 21 16h1z"/>
                                        </svg>
                                    </span>
                                    <div>
                                        <a href="tel:+919818548369">+91 9818548369</a><br />
                                        <a href="tel:+919818548369">+91 9818548369</a>
                                    </div>
                                </li>
                                <li>
                                    <span className="sf-contact-icon">
                                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none"
                                             stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <rect x="2" y="4" width="20" height="16" rx="2"/>
                                            <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
                                        </svg>
                                    </span>
                                    <a href="mailto:info@artecraftindia.com">info@artecraftindia.com</a>
                                </li>
                                <li>
                                    <span className="sf-contact-icon">
                                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none"
                                             stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <circle cx="12" cy="12" r="10"/>
                                            <polyline points="12 6 12 12 16 14"/>
                                        </svg>
                                    </span>
                                    <span>Mon – Sun: 10:00 AM – 10:00 PM</span>
                                </li>
                            </ul>
                        </div>

                    </div>
                </div>
            </div>

            {/* ── Divider ── */}
            <div className="sf-divider" />

            {/* ── Bottom bar ── */}
            <div className="sf-bottom">
                <div className="sf-container sf-bottom-inner">
                    <span className="sf-copyright">
                        © {new Date().getFullYear()} Arte Craft India. All rights reserved.
                    </span>
                    <div className="sf-bottom-links">
                        <Link to="/privacy-policy">Privacy Policy</Link>
                        <span className="sf-bottom-sep" />
                        <Link to="/terms-of-use">Terms of Use</Link>
                        <span className="sf-bottom-sep" />
                        <a href="#">Sitemap</a>
                    </div>
                    <div className="sf-made-in">
                        <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M12 21.593c-5.63-5.539-11-10.297-11-14.402 0-3.791 3.068-5.191 5.281-5.191 1.312 0 4.151.501 5.719 4.457 1.59-3.968 4.464-4.447 5.726-4.447 2.54 0 5.274 1.621 5.274 5.181 0 4.069-5.136 8.625-11 14.402z"/>
                        </svg>
                        Made in India
                    </div>
                </div>
            </div>

        </footer>
    )
};
export default Footer;